import React from 'react';
import { NavBar } from '@antonpodolsky/design-system/navigation/nav-bar/nav-bar';
import { NavBrand } from '@antonpodolsky/design-system/navigation/nav-brand/nav-brand';
import { NavLink } from '@antonpodolsky/design-system/navigation/nav-link/nav-link';
import { Cluster } from '@antonpodolsky/design-system/layout/cluster/cluster';
import { NavPill } from '@antonpodolsky/design-system/navigation/nav-pill/nav-pill';
import { cloudinaryImage } from '../../lib/cloudinary';

type NavPage = 'exif-reader' | 'exif-framer';

interface Props {
  size?: 'md' | 'lg';
  activePage?: NavPage;
}

const LOGO = cloudinaryImage('w_50/logo_abx39p.png');
const BLUESKY_LOGO = cloudinaryImage('w_20/bluesky_logo_iprxve.png');

export const SiteNav = ({ size, activePage }: Props) => (
  <NavBar size={size} brand={<NavBrand href="/" image={LOGO} name="Exify" />}>
    <Cluster gap="xl">
      <NavLink href="/exif-reader" active={activePage === 'exif-reader'}>
        EXIF Reader
      </NavLink>

      <NavLink href="/exif-framer" active={activePage === 'exif-framer'}>
        EXIF Framer
      </NavLink>
    </Cluster>

    <NavPill
      href="https://bsky.app/profile/exify-addon.bsky.social"
      image={BLUESKY_LOGO}
      label="Bluesky"
      title="Exify on Bluesky"
    />
  </NavBar>
);
